import React from "react";

const WarningModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div
      className={
        window.localStorage.getItem("MenuIsOpen") === "1"
          ? "alert-overlay"
          : "alert-overlay alert-overlay-big"
      }
    >
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="alert-body">
        <section className="alert-head">
          <h1>{translateText("unsaved_changes")}</h1>
          <button className="iconed" onClick={() => props.Close()}>
            <i className="feather-x"></i>
          </button>
        </section>
        <p>{translateText("candidate_comparison_warning_modal_text")}</p>
        <div className="unsaved-changes-footer">
          <button className="save-leave-btn" onClick={() => props.Close()}>
            {translateText("cancel")}
          </button>
          <button className="discard-leave-btn" onClick={() => props.Confirm()}>
            {translateText("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
